import { ApolloLink } from './ApolloLink';
export var split = ApolloLink.split;
//# sourceMappingURL=split.js.map